import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class TagsLanguageService {
  constructor(private http: HttpClient) {}

  getAllTags(): Observable<any> {
    return this.http.get(`${environment.authUrl}/tag`);
  }

  getLangauges(): Observable<any> {
    return this.http.get(`${environment.authUrl}/language`);
  }


  removeTag(id: any): Observable<any>{
    return this.http.delete(`${environment.authUrl}/tag/${id}`)
  }


  createTag(data: any): Observable<any>{
    return this.http.post(`${environment.authUrl}/tag`, data);
  }

  getAllTagsWithFilter(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/tag`,{
      headers: {lang: langCode},
      params: { searchTerm }
    });
  }

  getTagById(id:any){
    return this.http.get(`${environment.authUrl}/tag/${id}`);
  }

  updateTag(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/tag/${id}`, data);
  }
}
